import axios from '@axios'

const getDefaultState = () => ({
  items: [],
  item: null,
  options: null,
  statuses: [],
  searchFields: '',
  orderBy: '',
  sortedBy: '',
  summary: null,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 25,
    total: 0,
  },
})

export default {
  namespaced: true,
  state: getDefaultState,
  getters: {},
  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload
    },
    SET_PAGINATION(state, payload) {
      state.pagination = payload
    },
    SET_ITEM(state, payload) {
      state.item = { ...payload }
    },
    SET_OPTIONS(state, payload) {
      state.options = { ...payload }
    },
    SET_ADDITIONAL_OPTION(state, payload) {
      state.options = { ...state.options, ...payload }
    },
    SET_ITEM_SUMMARY(state, payload) {
      state.summary = { ...payload }
    },
    UPDATE_ITEM(state, payload) {
      state.items = state.items.map(item => {
        if (item.id === payload.id) {
          return payload
        }

        return item
      })
    },
    SET_STATUSES(state, payload) {
      state.statuses = payload.data.map(item => ({
        value: item.id,
        text: item.name,
      }))
    },
    SET_HARDWARE_STATUSES(state, payload) {
      state.hardwareStatuses = payload.data.map(item => ({
        value: item.id,
        text: item.name,
      }))
    },
    SET_SEARCH_FIELDS(state, fields) {
      state.searchFields = fields
    },
    SET_ORDER_BY(state, order) {
      state.orderBy = order
    },
    SET_SORTED_BY(state, field) {
      state.sortedBy = field
    },
    DELETE_ITEM(state, id) {
      state.items = state.items.filter(item => (item.id !== id))
    },
    RESET_ITEM(state) {
      state.item = null
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async getItems({ commit }, { ...payload }) {
      try {
        const { data } = await axios.get('/site/index', { params: { ...payload } })
        const { pagination } = data.meta
        const items = data.data.map(item => ({
          ...item,
          ...{ telephone: `${item.phone_country_code ? `+${item.phone_country_code}` : ''}${item.phone_number ?? ''}` },
        }))
        const { options } = data
        const {
          searchFields, search, orderBy, sortedBy,
        } = payload

        if (searchFields && search) {
          commit('SET_SEARCH_FIELDS', searchFields)
        }

        if (orderBy && sortedBy) {
          commit('SET_ORDER_BY', orderBy)
          commit('SET_SORTED_BY', sortedBy)
        }
        commit('SET_STATUSES', options.onlineStatuses)
        commit('SET_HARDWARE_STATUSES', options.statuses)
        commit('SET_ITEMS', items)
        commit('SET_PAGINATION', pagination)

        return data.data
      } catch (error) {
        commit('SET_ITEMS', [])
        return Promise.reject(error)
      }
    },
    async getItem({ commit }, id) {
      try {
        const { data } = await axios.get(`/site/${id}/show`)
        commit('SET_ITEM', data.data)
        commit('SET_ADDITIONAL_OPTION', data.options)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    async getItemOptionsList({ commit }) {
      try {
        const { data } = await axios.get('/site/options')
        commit('SET_OPTIONS', data.options)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    async getCompany({ commit }, id) {
      try {
        const { data } = await axios.get(`/company/${id}/show`)
        return data.data
      } catch (error) {
        console.log('no commit', commit)
        return Promise.reject(error)
      }
    },
    async getSiteSummary({ commit }, id) {
      try {
        const { data } = await axios.get(`/site/${id}/summary`)
        commit('SET_ITEM_SUMMARY', data.data)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    // eslint-disable-next-line no-unused-vars
    async createItem({ commit }, payload) {
      try {
        await axios.post('/site/store', {
          ...payload,
        })

        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async updateItem({ commit }, { id, ...payload }) {
      try {
        await axios.put(`/site/${id}/update`, {
          ...payload,
        })

        commit('UPDATE_ITEM', payload)

        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async deleteItem({ commit }, id) {
      try {
        await axios.delete(`/site/${id}/destroy`)

        commit('DELETE_ITEM', id)
        return true
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    setSearchFields({ commit }, payload) {
      commit('SET_SEARCH_FIELDS', payload)
    },

    setOrderBy({ commit }, payload) {
      commit('SET_ORDER_BY', payload)
    },
    setSortedBy({ commit }, payload) {
      commit('SET_SORTED_BY', payload)
    },
    async recoverItem({ commit }, id) {
      try {
        await axios.put(`/site/${id}/recover`)

        commit('RESET_ITEM')
        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
